import { categoryChipSx } from './categoryChipColor';

const PINNED_ACCOUNT_COLORS: Record<string, { bg: string; fg: string }> = {
  '…096': { bg: '#E7F5FF', fg: '#0A4B84' },
  '…084': { bg: '#E6FCF5', fg: '#0B6B44' },
  'cc …4601': { bg: '#FFE8CC', fg: '#7A4100' },
  joint: { bg: '#F3F0FF', fg: '#4A2A8A' },
  omar: { bg: '#E3FAFC', fg: '#0B5D6B' },
};

/** Filled tag colours for personal-finance account chips. */
export function accountTagChipSx(label: string | null | undefined): {
  backgroundColor?: string;
  color?: string;
  borderColor?: string;
} {
  const raw = String(label || '').trim();
  if (!raw) return {};
  const pinned = PINNED_ACCOUNT_COLORS[raw.toLowerCase()];
  if (pinned) {
    return {
      backgroundColor: pinned.bg,
      color: pinned.fg,
      borderColor: pinned.bg,
    };
  }
  return categoryChipSx(raw);
}
